import { useEffect, useState } from "react";

import Button from "./Button";

import SingleUserInformationNonEditable from "./SingleUserInformationNonEditable";
import SingleUserInformationNotes from "./SingleUserInformationNotes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import SingleUserInformationErrors from "./SingleUserInformationErrors";
import updateUserData from "../api/updateUserData"; // Adjust the import path as necessary
import { enqueueSnackbar } from 'notistack';
import e from "cors";

const userSchema = yup.object().shape({
  firstName: yup.string().required("wymagane"),
  lastName: yup.string().required("wymagane"),
  libraryCardNumber: yup.string().required("wymagany"),
});

const SingleUserInformation = ({ user }) => {
  const [editing, setEditing] = useState(false);
  const [userData, setUserData] = useState(user || {});

  useEffect(() => {
    setUserData(user || {});
  }, [user]);

  // Toggle editing mode
  const toggleEditing = () => {
    // If currently editing and there are errors, prevent toggling
    if (editing && Object.keys(errors).length > 0) {
      return; // Don't toggle the editing state
    }
    setEditing(!editing);
  };

  // Form submission handler
  // Update the useForm configuration
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
    clearErrors } = useForm({
      resolver: yupResolver(userSchema),
      mode: "onChange", // Change to validate as user types
      defaultValues: {
        firstName: user?.name || "",
        lastName: user?.surname || "",
        libraryCardNumber: user?.lib_card_number || ""
      }
    });

  // When editing starts, ensure form values are set from current user data
  useEffect(() => {
    if (editing) {
      setValue("firstName", userData?.name || "");
      setValue("lastName", userData?.surname || "");
      setValue("libraryCardNumber", userData?.lib_card_number || "");
    }
  }, [editing, user, setValue]);
  // Form submission handler 
  const onSubmit = async (data) => {
    console.log("Form submitted with data:", data);

    try {
      // Update local state
      const updatedUserData = {
        ...userData,
        name: data.firstName,
        surname: data.lastName,
        lib_card_number: data.libraryCardNumber
      };

      console.log("Updating user data to:", updatedUserData);
      setUserData(updatedUserData);

      //  call an API to update the user data
      // Create payload with only changed fields
      const payload = { id: user.id };

      if (data.firstName !== user.name) {
        payload.name = data.firstName;
      }

      if (data.lastName !== user.surname) {
        payload.surname = data.lastName;
      }

      if (data.libraryCardNumber !== user.lib_card_number) {
        payload.lib_card_number = data.libraryCardNumber;
      }

      // Check if any changes were made
      if (Object.keys(payload).length <= 1) {
        enqueueSnackbar("Nic się nie zmieniło.", { variant: "info" });
        setEditing(false);
        return;
      }

      try {
        await updateUserData(payload);
      } catch (e) {
        enqueueSnackbar(e.message, { variant: "error" });
        return;
      }

      // Exit editing mode
      setEditing(false);
      setUserData(updatedUserData);
      enqueueSnackbar("Zaktualizowano.", { variant: "success" });
    } catch (error) {
      console.error("Error during form submission:", error);
      enqueueSnackbar("Wystąpił błąd podczas przetwarzania formularza.", { variant: "error" });
    }
  };

  return (
    <div
      className="container"
      style={{
        textAlign: "center",
        maxWidth: "100%",
      }}
    >
      <table width="100%" ></table>

      <table width="100%" >
        <tr><td width="33%"><div style={{
          textAlign: "left",
          fontSize: "3vh",
          position: "relative",
          top: "2vh",
        }}>DANE CZYTELNIKA
          {editing ? " - edycja" : ""}
        </div><p /></td></tr>
        <tr><td colSpan={2}><div style={{
          fontSize: "3vh",
          backgroundColor: "#eee",
          position: "relative",
          top: "1vh",
          boxShadow: "4px 4px 3px 0px rgba(0,0,0,0.2)",
        }}>
          {!editing ? (
            <b>{userData?.name} {userData?.surname}</b>
          ) : (
            <table style={{ width: "100%", fontSize: "2vh" }}>
              <tbody>
                <tr>
                  <td>
                    <div style={{ margin: "5px" }}>
                      <label htmlFor="nameInput" style={{ marginRight: "5px", fontWeight: "bold" }}>Imię:</label>
                      <input
                        id="nameInput"
                        name="firstName"
                        type="text"
                        defaultValue={userData?.name}
                        style={{ fontSize: "2vh" }}
                        {...register("firstName")}
                        onChange={(e) => {
                          setValue("firstName", e.target.value);
                        }}
                      />
                    </div>
                  </td>
                  <td>
                    <div>
                      <label htmlFor="lastnameInput" style={{ marginRight: "5px", fontWeight: "bold" }}>Nazwisko:</label>
                      <input
                        id="lastnameInput"
                        name="lastName"
                        type="text"
                        defaultValue={userData?.surname}
                        style={{ fontSize: "2vh" }}
                        {...register("lastName")}
                        onChange={(e) => {
                          setValue("lastName", e.target.value);
                        }}
                      />
                    </div>
                  </td>
                  <td>
                    <div>
                      <label htmlFor="libCardInput" style={{ marginRight: "5px", fontWeight: "bold" }}>Nr karty:</label>
                      <input
                        id="libCardInput"
                        name="libraryCardNumber"
                        type="text"
                        defaultValue={userData?.lib_card_number}
                        style={{ fontSize: "2vh" }}
                        {...register("libraryCardNumber")}
                        onChange={(e) => {
                          setValue("libraryCardNumber", e.target.value);
                        }}
                      />
                    </div>
                  </td>
                </tr>
                {/* <tr>
                  <td >
                    <div style={{ marginRight: "15px" }}>
                      <label htmlFor="emailInput" style={{ marginRight: "5px", fontWeight: "bold" }}>Email:</label>
                      <input
                        id="emailInput"
                        name="email"
                        type="text"
                        defaultValue={userData?.email}
                        style={{ fontSize: "2vh" }}
                        {...register("email")}
                        onChange={(e) => {
                          setValue("email", e.target.value);
                        }}
                      />
                    </div>
                  </td>
                  <td >
                    <div style={{ marginRight: "15px" }}>
                      <label htmlFor="phoneInput" style={{ marginRight: "5px", fontWeight: "bold" }}>Telefon:</label>
                      <input
                        id="phoneInput"
                        name="phone"
                        type="text"
                        defaultValue={userData?.phone_number}
                        style={{ fontSize: "2vh" }}
                        {...register("phone")}
                        onChange={(e) => {
                          setValue("phone", e.target.value);
                        }}
                      />
                    </div>
                  </td>
                </tr> */}
              </tbody>
            </table>
          )}

        </div></td>
        </tr>

        <tr>
          {editing && <SingleUserInformationErrors errors={errors} user={user} />}
        </tr>
        <tr>
          {!editing && <SingleUserInformationNonEditable
            user={userData}
          />}
        </tr>
        <tr>
          {!editing && <SingleUserInformationNotes user={user} />}
        </tr></table>
      {editing && (
        <div style={{
          position: "absolute",
          bottom: "10px",
          right: "10px",
          display: "flex",
          gap: "10px",
        }}>
          <Button
            text="Anuluj"
            onClick={() => {
              // Clear all form errors
              clearErrors();

              // Reset form values to initial state
              reset({
                firstName: user?.name || "",
                lastName: user?.surname || "",
                libraryCardNumber: user?.lib_card_number || ""
              });

              // Exit editing mode
              setEditing(false);
            }}
          />          <Button
            text="Zapisz"
            onClick={handleSubmit((data) => {
              onSubmit(data);
            })}
          />
        </div>
      )}
      {!editing && (
        <Button
          onClick={toggleEditing}
          text={
            <FontAwesomeIcon
              icon={faEdit}
            />
          }
          styleOptions={{
            maxWidth: "40px",
            width: "40px",
            padding: "9px 7px 9px 9px",
            position: "absolute",
            top: "10px",
            right: "10px",
          }}
        />)}
    </div >
  );
};

export default SingleUserInformation;
